import {Component, OnInit} from '@angular/core';
import {ContractualDataService} from './service/contractual-data.service';
import * as servers from '../../services/api/servers';
import {urls} from '../../services/api/urls';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-contractual-data',
  templateUrl: './contractual-data.component.html',
  styleUrls: ['./contractual-data.component.scss']
})
export class ContractualDataComponent implements OnInit {

  contractualDataUrl: string;
  reportSection: boolean;

  constructor(private contractualDataService: ContractualDataService,
              private _Activatedroute: ActivatedRoute) {
  }

  ngOnInit() {
    this.contractualDataUrl = servers.apiUrl + urls.cobidbService + urls.contractualData;
    // this.contractualDataService.getAll(this.contractualDataUrl, null );
    this._Activatedroute.queryParams.subscribe(params => {
      this.reportSection = params['reportSection'];
    });
  }

}
